/*
 * File: index.tsx
 * Desc: 操作类图标
 * File Created: 2019-09-12 15:53:04
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'antd';

type IconOpProps = {
    title?: string;
    icon: string;
    color?: string;
    style?: React.CSSProperties;
    className?: string;
    children?: React.ReactDOM;
    onClick: () => void;
};

/**
 * 操作类图标
 * @param props
 */
const IconOp = (props: IconOpProps) => (
    <span className="op_icon">
        <Tooltip title={props.title || props.children}>
            <i
                onClick={props.onClick}
                style={{ color: props.color, ...props.style }}
                className={classNames('icon-666', 'karakal-icon-' + props.icon, props.className)}
            />
        </Tooltip>
    </span>
);

export default IconOp;
